import { useMemo } from 'react';

import { PlaneWrapper, IconWrapper, PlaneIcon } from './Plane.style';

const Plane = ({
  statusDescription: status,
  operationalTimes: { actualGateArrival, actualGateDeparture },
}) => {
  const planePosition = useMemo(() => {
    let position = '';
    if (actualGateArrival) position = '100%';
    else if (!actualGateArrival && actualGateDeparture) position = '50%';
    else if (actualGateDeparture) position = '0';

    return position;
  }, [actualGateArrival, actualGateDeparture]);

  return (
    <PlaneWrapper canceled={status.startsWith('C').toString()}>
      {!status.startsWith('C') && (
        <IconWrapper left={planePosition}>
          <PlaneIcon />
        </IconWrapper>
      )}
    </PlaneWrapper>
  );
};

export default Plane;
